import { carrieMediaArray } from './carrieMedia'
import { carrieBio } from './carrieBios'
import { aidenReviewerReviewTinder, mrBigReviewerReviewHinge, burgerReviewerReviewBumble } from './carrieReviewerReviews'
import { aidenReviewerProfile, mrBigReviewerProfile, burgerReviewerProfile } from './carrieReviewers'

export const mrBigProfileReviewHinge = {
  _id: 'mrBigProfileReviewHingeId',
  userId: 'carrieUserId',
  userEmail: 'carrie@email.com',
  datingProfileId: 'carrieDatingProfileHingeId',
  reviewerProfileId: 'mrBigReviewerProfileId',
  reviewerEmail: 'mrBig@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: carrieMediaArray[9]._id,
      mediaItemURL: carrieMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[9].type,
      caption: carrieMediaArray[9].captions[2],
      subcaption: carrieMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: carrieMediaArray[1]._id,
      mediaItemURL: carrieMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[1].type,
      caption: carrieMediaArray[1].captions[1],
      subcaption: carrieMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[4]._id,
      mediaItemURL: carrieMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[4].type,
      caption: carrieMediaArray[4].captions[0],
      subcaption: carrieMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[6]._id,
      mediaItemURL: carrieMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[6].type,
      caption: carrieMediaArray[6].captions[0],
      subcaption: carrieMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[7]._id,
      mediaItemURL: carrieMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[7].type,
      caption: carrieMediaArray[7].captions[1],
      subcaption: carrieMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[8]._id,
      mediaItemURL: carrieMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[8].type,
      caption: carrieMediaArray[8].captions[1],
      subcaption: carrieMediaArray[8].subcaptions[1],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Love the outfit and vibe Carrie, you look super chic here. I hate animals too, it's why I live in the city, far away from any howling coyotes.`,
      verdict: 'Very',
    },
    {
      feedback: `Wow you're a stunner! 2-for-2 so far! I'd love to be walking down the street with you smiling and looking chic by my side.`,
      verdict: 'Very',
    },
    {
      feedback: `Another fantastic outfit and smile. Definitely what you should wear when I introduce you to my mom!`,
      verdict: 'Very',
    },
    {
      feedback: `You look serious here, like maybe you just yelled at a boyfriend or something. I've been yelled at before and don't particularly enjoy it. Still, the outfit is good, and you look chic, just serious.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `That's a super cozy work from home arrangement that you've got. I'm guessing the sheets match the curtains? Love that you're engaged in your work.`,
      verdict: 'Very',
    },
    {
      feedback: `Photo quality and cropping aren't up to your standards here! Definitely the weakest link on your profile. I'm sure you can do better here!`,
      verdict: 'No',
    }
  ],
  bio: {
    bioItemsId: carrieBio._id,
    vitalInfo: { ...carrieBio.vitalInfo },
    prompts: [
      { ...carrieBio.prompts[0] },
      { ...carrieBio.prompts[1] },
      { ...carrieBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You're enough younger than me that people on the street might not approve — which to me is perfect. Also you seem smart and accomplished, yadda yadda`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: ``,
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `You're in luck, you won't catch me out of my apartment in anything else`,
        verdict: 'Very', 
      },
      {
        feedback: `You're a real city girl. I like these things too. Feel free to change my curtains and sheets to your pleasing.`,
        verdict: 'Yes', 
      },
      {
        feedback: `Hmm how about plaid AND stripes. Just kidding. I don't really care about fashion, and most guys see it as an expensive diversion.`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `You're very chic and clever. Only the classiest men in the city would do you justice`,
    good: `Your outfits, smiles, and wit are all elite!`,
    notGood: `There's one blurry photo that can be changed. Also, all the expensive clothes might have guys looking at their bank accounts and concluding they can't afford to date you`,
    verdict: `I think you're a total catch and that we'd really hit it off! If you're trying solely to match with a guy like me, who wears suits and does expensive things, you're profile perfect. If you'd like to appeal to a broader group of guys, a casual photo or two would help you do that.`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...mrBigReviewerReviewHinge },
  reviewerProfile: { ...mrBigReviewerProfile },
  bioItems: { ...carrieBio },
  mediaItems: [ ...carrieMediaArray ],
}

export const burgerProfileReviewBumble = {
  _id: 'burgerProfileReviewBumbleId',
  userId: 'carrieUserId',
  userEmail: 'carrie@email.com',
  datingProfileId: 'carrieDatingProfileBumbleId',
  reviewerProfileId: 'burgerReviewerProfileId',
  reviewerEmail: 'burger@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: carrieMediaArray[4]._id,
      mediaItemURL: carrieMediaArray[4].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[4].type,
      caption: carrieMediaArray[4].captions[0],
      subcaption: carrieMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[8]._id,
      mediaItemURL: carrieMediaArray[8].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[8].type,
      caption: carrieMediaArray[8].captions[1],
      subcaption: carrieMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[1]._id,
      mediaItemURL: carrieMediaArray[1].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[1].type,
      caption: carrieMediaArray[1].captions[1],
      subcaption: carrieMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[6]._id,
      mediaItemURL: carrieMediaArray[6].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[6].type,
      caption: carrieMediaArray[6].captions[0],
      subcaption: carrieMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[7]._id,
      mediaItemURL: carrieMediaArray[7].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[7].type,
      caption: carrieMediaArray[7].captions[1],
      subcaption: carrieMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[9]._id,
      mediaItemURL: carrieMediaArray[9].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[9].type,
      caption: carrieMediaArray[9].captions[2],
      subcaption: carrieMediaArray[9].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Someone I'd certainly introduce to my mom. A perfect Hampton's outfit too!`,
      verdict: 'Very',
    },
    {
      feedback: `This is a blurry photo. You still look chic here, but with the cropping the coffee cup is awkward too. I bet you have a better headshot`,
      verdict: 'No',
    },
    {
      feedback: `Wow! What a babe! Love the smile, the outfit, and the vibe!`,
      verdict: 'Very',
    },
    {
      feedback: `So serious. I feel like I was just yelled at.`,
      verdict: 'No',
    },
    {
      feedback: `Love it! I'm a writer too and am doing the exact same thing, making the exact same face at midnight before a deadline`,
      verdict: 'Very',
    },
    {
      feedback: `You look chic here. I don't care mychg about animal rights, we're good on that front. One concern is that my writer salary can't afford your wardrobe, so I hope there's money on your side somewhere`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: carrieBio._id,
    vitalInfo: { ...carrieBio.vitalInfo },
    prompts: [
      { ...carrieBio.prompts[0] },
      { ...carrieBio.prompts[1] },
      { ...carrieBio.prompts[2] }
    ],
    aboutMe: carrieBio.aboutMe[0],
    hobbies: [carrieBio.hobbies[0], carrieBio.hobbies[1], carrieBio.hobbies[2], carrieBio.hobbies[3], carrieBio.hobbies[4] ],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `I love that you're also a writer! You seem super intelligent and well oriented`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: `Love it! You had me at 'melodrama'! You're a talented humorist`,
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `I don't where suits honey. If you're lucky you'll find me in khakis and a tweed jacket, but my natural state is white T-shirts, underwear, and leftover Chinese food`,
        verdict: 'No', 
      },
      {
        feedback: `Let's do all three in one day!`,
        verdict: 'Very', 
      },
      {
        feedback: `Isn't stripes just plaid with half the budget? Obviously team plaid here!`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `You're very classy, into fashion, culture, and society, but you also have sharp wit and don't seem pretentious`,
    good: `You're super chic! Super cool too. And I love that you're a writer!`,
    notGood: `One concern is that my writer salary can't afford your wardrobe, so I hope there's money on your side somewhere`,
    verdict: `You're a total catch, and we're a great match. I'll wear my best striped-plaided tie to our first date. That said, there are ways for your profile to appeal to a broader group of guys, namely adding in a few more casual pics with your glamorous ones. Right now I'd love to date you but I'm worried I couldn't afford you.`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...burgerReviewerReviewBumble },
  reviewerProfile: { ...burgerReviewerProfile },
  bioItems: { ...carrieBio },
  mediaItems: [ ...carrieMediaArray ],
}

export const aidenProfileReviewTinder = {
  _id: 'aidenProfileReviewTinderId',
  userId: 'carrieUserId',
  userEmail: 'carrie@email.com',
  datingProfileId: 'carrieDatingProfileTinderId',
  reviewerProfileId: 'aidenReviewerProfileId',
  reviewerEmail: 'aiden@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: carrieMediaArray[9]._id,
      mediaItemURL: carrieMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[9].type,
      caption: carrieMediaArray[9].captions[2],
      subcaption: carrieMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: carrieMediaArray[1]._id,
      mediaItemURL: carrieMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[1].type,
      caption: carrieMediaArray[1].captions[1],
      subcaption: carrieMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[4]._id,
      mediaItemURL: carrieMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[4].type,
      caption: carrieMediaArray[4].captions[0],
      subcaption: carrieMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[6]._id,
      mediaItemURL: carrieMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[6].type,
      caption: carrieMediaArray[6].captions[0],
      subcaption: carrieMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[7]._id,
      mediaItemURL: carrieMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[7].type,
      caption: carrieMediaArray[7].captions[1],
      subcaption: carrieMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[8]._id,
      mediaItemURL: carrieMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[8].type,
      caption: carrieMediaArray[8].captions[1],
      subcaption: carrieMediaArray[8].subcaptions[1],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look super chic here, but I'm not a fan of fur coats. Where is your moral compass with respect to animal welfare? Still, you look super chic.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Wow! You're a bombshell. Definitely super chic in the dress and the urban setting. Great smile too!`,
      verdict: 'Very',
    },
    {
      feedback: `Another great photo of you! Love the outfit and the smile! Definitely someone I'd introduce to my mom!`,
      verdict: 'Very',
    },
    {
      feedback: 'Love the outfit and your hair. You have a bit of a weird facial expression in the photo though. Not a dealbreaker, but I bet you have a better one',
      verdict: 'Somewhat',
    },
    {
      feedback: 'Love this! Being engaged in your work is super important, and it looks like you have a cozy home life too! The caption is funny too!',
      verdict: 'Very',
    },
    {
      feedback: `You look chic here, but the cropping is a bit off and the photo is a bit blurry. I'm sure there's a better photo of you`,
      verdict: 'No',
    }
  ],
  bio: {
    bioItemsId: carrieBio._id,
    vitalInfo: { ...carrieBio.vitalInfo },
    prompts: [
      { ...carrieBio.prompts[0] },
      { ...carrieBio.prompts[1] },
      { ...carrieBio.prompts[2] }
    ],
    aboutMe: carrieBio.aboutMe[0],
    hobbies: [carrieBio.hobbies[0], carrieBio.hobbies[1], carrieBio.hobbies[2], carrieBio.hobbies[3], carrieBio.hobbies[4] ],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Everything is fine, you seem like a total catch — except there are quite few people out there who see smoking as a dealbreaker`,
      verdict: 'No', 
    },
    aboutMeFeedback: {
      feedback: 'Love that snappy wit of yours',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Bad news: suits aren't typically worn at my cabin in the Catskills. Is a denim suit OK?`,
        verdict: 'No', 
      },
      {
        feedback: `I like all those things too. Sounds like wonderful first three dates we'll have`,
        verdict: 'Yes', 
      },
      {
        feedback: `Not a big fashion guy, but I'm partial to stripes... Not sure you'll meet many straight guys with strong opinions on this topic. Maybe a different conversation starter would work better.`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: 'Carrie is exceptionally chic and has a fun wit to her as well.',
    good: 'Your outfits are stunning and you seem like someone who can hold a super engaging and fun conversation',
    notGood: `I'm not sure that you feel in your element in casual situations, and especially in a place like my cabin in the Catskills, where I like to go several times a month. I'm also not sure you make healthy life choices, considering your smoking habit`,
    verdict: `I think you're a total catch, and a lot of people will be excited to match with you. However, there are guys who might be turned off by the 'fashionista' vibe because you'll be 'expensive' or because they like spending time casually or in nature, so if there's a good photo of you in simple jeans and a T-shirt in an apple orchard or a pumpkin patch, that might increase the variety of guys you match with.`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...aidenReviewerReviewTinder },
  reviewerProfile: { ...aidenReviewerProfile },
  bioItems: { ...carrieBio },
  mediaItems: [ ...carrieMediaArray ],
}
